//#region Angular
//#endregion
//#region HTTP

import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//#endregion
//#region Routing
import { Router, RouterModule } from '@angular/router';
//#endregion
//#region Translate
import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialCssVarsModule } from 'angular-material-css-vars';
import 'chart.js/dist/chart.min.js';
import { TreeDragDropService } from 'primeng/api';
//#endregion
import { routes } from '../app.routing';
//#endregion
//#region Injector
import { DialogHelper, InjectorHelper, RoutingHelper, TranslateHelper } from '../helpers/injector.helper';
import { APP_ACTIONS } from '../imports/app.actions';
import { APP_COMMON } from '../imports/app.common';
import { APP_CHART, APP_CONTROLS, APP_DATATABLE, APP_STATIC_CONTROLS } from '../imports/app.controls';
import { APP_CDATA_CONNECTORS, APP_DATAMODEL } from '../imports/app.datamodel';
//#endregion
//#region includes
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateTimeAdapter, OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { GridsterModule } from 'angular-gridster2';
import { AngularSplitModule } from 'angular-split';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { QuillModule } from 'ngx-quill';
import { ToastrModule } from 'ngx-toastr';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TabViewModule } from 'primeng/tabview';
import { DataTableTranslateHelper } from '../helpers/translate.helper';
import { MW_COMPONENTS } from '../imports/app.components';
import { APP_DECLARATIONS } from '../imports/app.declarations';
import { APP_DIALOGS } from '../imports/app.dialogs';
import { APP_EXPORTS, MW_DIALOGS, MW_EXPORTS } from '../imports/app.exports';
import { APP_DIRECTIVES, APP_PIPES } from '../imports/app.helpers';
import { APP_LAYOUTS } from '../imports/app.layouts';
import { APP_MEDIATYPES } from '../imports/app.mediatypes';
import { APP_MENUTABS } from '../imports/app.menutabs';
import { APP_MULTIPANELS } from '../imports/app.multipanels';
import { MW_SERVICES } from '../imports/app.mw.services';
import { OthersModule } from '../imports/app.others';
import { APP_PAGES } from '../imports/app.pages';
import { APP_SERVICES } from '../imports/app.services';
import { APP_SETTINGS } from '../imports/app.settings';
import { APP_THEME_CONTROLS } from '../imports/app.themecontrols';
import { APP_WIDGETS } from '../imports/app.widgets';
import { APP_WIZARDS } from '../imports/app.wizards';
import { MAC_DIALOGS } from '../imports/mac.dialogs';
import { MAC_MENUTABS } from '../imports/mac.menutabs';
import { MAC_DIRECTIVES, MAC_SERVICES } from '../imports/mac.services';
import { MaterialModule } from '../imports/material.module';
import { PrimeNgModule } from '../imports/primeng.module';
import { APP_DEPLOYMENTACTIONS_CONTROLS } from '../registries/actions/actions.registry';
import { APP_DATAMODEL_SETTINGS, APP_MW_PIPES, APP_MW_SETTINGS } from '../registries/settings/app.mw.settings';
import { MAC_SETTINGS } from '../registries/settings/mac.settings';
import { MAC_TASKS } from '../registries/tasks/mac.tasks';
import { MW_WORKFLOW } from '../registries/workflows/app.mw.workflow';
import { MAC_WORKFLOWS } from '../registries/workflows/mac.workflows';
import { APP_WORKFLOW } from '../registries/workflows/workflow.registry';
import { BasicAuthInterceptor } from '../services/basic_auth.interceptor';
import { GADateTimeAdapter, GAIntl } from '../services/owl.services';
import { AppMissingTranslationHandler, TranslationLoader } from '../services/translation.service';
import { AppFrameworkComponent } from './appframework.component';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { APP_INTEGRATION } from '../imports/app.integration';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslationLoader(http);
}

export const TooltipOptions: MatTooltipDefaultOptions = {
    showDelay: 0,
    hideDelay: 0,
    touchendHideDelay: 0,
    disableTooltipInteractivity: true,
}

//#endregion
@NgModule({
    declarations: [
        AppFrameworkComponent,
        APP_DECLARATIONS,
        APP_MENUTABS,
        APP_CONTROLS,
        APP_STATIC_CONTROLS,
        APP_THEME_CONTROLS,
        APP_DIALOGS,
        APP_PAGES,
        APP_LAYOUTS,
        APP_PIPES,
        APP_DIRECTIVES,
        APP_WORKFLOW,
        APP_ACTIONS,
        APP_DATAMODEL,
        APP_CDATA_CONNECTORS,
        APP_COMMON,
        APP_SETTINGS,
        APP_WIZARDS,
        APP_WIDGETS,
        APP_DEPLOYMENTACTIONS_CONTROLS,
        APP_MEDIATYPES,
        MW_COMPONENTS,
        APP_MW_SETTINGS,
        APP_DATAMODEL_SETTINGS,
        MW_WORKFLOW,
        APP_MW_PIPES,
        MW_DIALOGS,
        APP_MULTIPANELS,
        MAC_DIALOGS,
        MAC_SETTINGS,
        MAC_MENUTABS,
        MAC_TASKS,
        MAC_DIRECTIVES,
        MAC_WORKFLOWS,
        APP_DATATABLE,
        APP_CHART,
        APP_INTEGRATION
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        InfiniteScrollModule,
        MaterialModule,
        PrimeNgModule,
        OwlDateTimeModule,
        QuillModule.forRoot(),
        OwlNativeDateTimeModule,
        MonacoEditorModule.forRoot(),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OthersModule,
        HttpClientModule,
        PrimeNgModule,
        VirtualScrollerModule,
        ContextMenuModule,
        DragDropModule,
        GridsterModule,
        TabViewModule,
        NgxJsonViewerModule,
        AngularSplitModule,
        RouterModule.forRoot(routes, {
            useHash: false
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: AppMissingTranslationHandler
            }
        }),
        MaterialCssVarsModule.forRoot({
            isAutoContrast: true,
            darkThemeClass: 'isDarkTheme',
            lightThemeClass: 'isLightTheme',
        }),
        ToastrModule.forRoot()
    ],
    providers: [
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: TooltipOptions },
        /*{ provide: OWL_DATE_TIME_LOCALE, useValue: 'de' },*/
        { provide: DateTimeAdapter, useClass: GADateTimeAdapter },
        { provide: OwlDateTimeIntl, useClass: GAIntl },
        TreeDragDropService,
        APP_SERVICES,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BasicAuthInterceptor,
            multi: true
        },
        MW_SERVICES,
        MAC_SERVICES
    ],
    exports: [
        AppFrameworkComponent,
        APP_EXPORTS,
        APP_DIRECTIVES,
        APP_PIPES,
        MW_EXPORTS,
        APP_MULTIPANELS,
        APP_CONTROLS,
        ContextMenuModule,
        MAC_DIALOGS,
        MAC_SETTINGS,
        MAC_MENUTABS,
        MAC_TASKS,
        MAC_DIRECTIVES
    ]
})
export class AppFrameworkModule {
    constructor(private injector: Injector, private dialog: MatDialog, private translate: TranslateService, private router: Router) {
        InjectorHelper.InjectorInstance = this.injector;
        DialogHelper.DialogInstance = this.dialog;
        TranslateHelper.TranslatorInstance = this.translate;
        DataTableTranslateHelper.TranslatorInstance = this.translate;
        RoutingHelper.Router = this.router;
    }
}
